<template>
  <v-container grid-list-xs class="pa-0 ma-0" fluid>
    <v-row class="pa-0 ma-0 titlesdark--text">
      <v-col md="8" sm="12" class="pa-0 ma-0 mt-1">
        <span class="pl-1 text-light font-size-2">Conexiones</span>
      </v-col>
       <v-col md="12" sm="12" cols="12" class="pa-0 ma-0">
        <v-breadcrumbs
          class="py-2 px-0"
          :items="aItemsBreadcrumbs"
          divider=">"
        >
         <template v-slot:item="{ item }">
          <v-breadcrumbs-item class="titlesdark--text">
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="pa-0 ma-0">
      <v-col md="12" sm="12" class="pa-0 ma-0">
        <grid
          :tabla="sNombreTabla"
          :bActiveFilter="true"
          :bActiveExport="true"
          :bSingleSelect="true"
          :bShowSelect="true"
          :sIdTable="'CodProducto'"
          :bShowMapDetails="false"
          :bActiveNew="true"
          :aInfoTBDetalleExp="aDetallesExport"
          @idSelect="onCargarIdSelect"
          @nameField="onCargarNombreSelect"
        >
        </grid>
      </v-col>
    </v-row>
    <ModalExterno
      :bShowModal="bShowModal"
      :sTable="sTableModal"
      :sTitle="sTitleModal"
      @input="changeStateModal">
    </ModalExterno>
  </v-container>
</template>

<script>
import grid from '@/components/Grid/Grid.vue'
import ModalExterno from '@/components/ModalExterno.vue'
export default {
  name:"Clientes",
  components: {
    grid,
    ModalExterno,
  },
  data() {
    return {
      nIdSeleccionado: 0,                  // Id seleccionado
      sNombreCampoFiltro: '',                 // Nombre del campo foreignKey
      bShowModal: false,             // Habilita o deshabilita modal externo
      sTableModal: '',               // Nombre tabla a trabajar sobre el modal
      sTitleModal: '',               // Titlulo del modal
      sNombreTabla: 'Conexiones',
      aDetallesExport : [],
      aItemsBreadcrumbs: [
        {
          text: 'Inicio',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Seguridad',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Conexiones',
          disabled: true,
          href: 'breadcrumbs_dashboard',
        },
      ],
    }
  },// fin data
  methods: {
    changeStateModal(bNewValue) {
      this.bShowModal = bNewValue;
    },
    onCargarIdSelect(sIdSelected) {
      this.nIdSeleccionado = sIdSelected;
    },
    onCargarNombreSelect(sNameFiled) {
      this.sNombreCampoFiltro = sNameFiled;
    }
  },
}
</script>

<style scoped>

</style>